<template>
  <div class="row">
    <!--Title-->
    <div class="text-right col-md-12">
            <p-button 
                v-if="tableData && tableData.length && !this.$apollo.queries.regionals.loading"
                @click="handleAdd" 
                type="warning" 
                outline>Agregar regional
                <i class="ml-2 fa fa-plus"></i>
            </p-button>
            <h4 class="title center-title pull-left">Regionales</h4>
    </div>
    <!--./Title-->
    <!--Loading state-->
    <loading :active.sync="this.$apollo.queries.regionals.loading"
    :can-cancel="false" 
    :is-full-page="fullPage">
    </loading>
    <!--./Loading state-->
    <!--Sending state-->
    <loading :active.sync="isSending"
    :can-cancel="false" 
    :is-full-page="fullPage">
    </loading>
    <!--./Sending state-->
    <!--Empty state-->
    <div v-if="tableData && !tableData.length && !this.$apollo.queries.regionals.loading" class="mt-3 col-md-12 card">
      <div class="card-header">
      </div>
      <div class="card-body">
        <img class="no_data_center"  v-bind:src="no_data_image" alt="">
      </div>
      <div class="card-footer text-center">
        <p-button 
            @click="handleAdd" 
            type="warning" 
            outline>Agregar regional
            <i class="ml-2 fa fa-plus"></i>
        </p-button>            
      </div>
    </div>
    <!--./Empty state-->
    <!--Regionals data-->
    <div v-if="tableData &&  tableData.length && !this.$apollo.queries.regionals.loading" class="col-md-12 card">
      <div class="card-header">
        <div class="category">Lista de regionales</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-4">
          <div>
            <fg-input class="input-sm"
                      placeholder="Buscar"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                            :key="column.label"
                            :min-width="column.minWidth"
                            :prop="column.prop"
                            :label="column.label">
            </el-table-column>
            <el-table-column
              :min-width="120"
              fixed="right"
              class-name="td-actions"
              label="Acciones">
              <template slot-scope="props">
                <el-tooltip content="Editar" placement="left">
                  <p-button type="primary" size="sm" icon @click="handleEdit(props.$index, props.row)">
                    <i class="fa fa-edit"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip v-show="props.row.isActive" content="Desactivar" placement="right">
                  <p-button type="danger" size="sm" icon @click="handleDeactivate(props.$index, props.row)">
                    <i class="fa fa-pause"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip  v-show="!props.row.isActive" content="Activar" placement="right">
                  <p-button type="success" size="sm" icon @click="handleActivate(props.$index, props.row)">
                    <i class="fa fa-play"></i>
                  </p-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Mostrando {{from + 1}} a {{to}} de {{total}} registros</p>
        </div>
        <div class="col-sm-12 mt-2">
          <el-select
            class="select-default pull-left"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
    <!--./Regionals data-->
    <!--Add Regional form-->
    <div v-if="(addRegional == true || editRegional == true) && !this.$apollo.queries.regionals.loading" class="col-md-12 card">
        <form>
            <div class="card-header">
                <h4 class="card-title">
                {{formName}}
                </h4>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Código de regional</label>
                    <fg-input   :disabled="editRegional"
                                ref="code"
                                type="number"
                                name="código"
                                autocomplete="off"
                                v-validate="modelValidations.code"
                                :error="getError('código')"
                                v-model="model.code"
                                autofocus>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Nombre de regional</label>
                    <fg-input   
                                ref="name"
                                type="text"
                                name="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.name"
                                :error="getError('nombre')"
                                v-model="model.name">
                    </fg-input>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button type="success" @click.prevent="validate">Aceptar</p-button>
                    <p-button type="default" class="pull-left" @click="cancelForm">Cancelar</p-button>
                </div>
            </div>
        </form>
    </div>
    <!--./Add Regional form-->
  </div>
  
</template>
<script>
  import swal from 'sweetalert2'
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { Tooltip } from 'element-ui'
  import gql from 'graphql-tag'
  import { regionals } from 'src/api/graphql/queries/setup/AllRegionals';
  import { CREATE_REGIONAL } from 'src/api/graphql/mutations/setup/AddEditRegionals';
  import { orderBy , sortBy , find } from 'lodash';
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    /***
    * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
    *
    **/
    apollo:{
      regionals: {
                query: regionals,
                skip: false,
                fetchPolicy: 'network-only',
                // Si tenemos un resultado, pero no encontró el slug.
                result({ data, loading, networkStatus }) {
                    
                    if(data.regionals.edges.length == 0)
                    {
                        this.regionals = [];
                    }
                    else
                    {
                        this.setRegionals(data.regionals);
                        this.$apollo.queries.regionals.skip = true;
                    }
                    
                },
                // Si encontró algún error.
                error(error) {
                    
                },
              },
      },
    components: {
      PPagination,
      Loading,
      [Tooltip.name]: Tooltip
    },
    computed: {
      // tableData(){
      //   return this.regionals_array
      // },
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString().toLowerCase();
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
        no_data_image : process.env.VUE_APP_BASE_ROUTE+'img/no_data.png',
        isSending: false,
        fullPage: false,
        tableData: [],
        regionals_array : [],
        addRegional : false,//Bandera de creación de regional
        editRegional : false,//Bandera de edición de regional
        rowEdit: {},
        formName: 'Cargando...',//Nombre del formulario de creación/edición
        model: {
          id: '',
          code: '',
          name: ''
        },
        modelValidations: {
          code: {
            required: true,
            max: 8
          },
          name: {
            required: true,
            max: 32
          },
        },
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['code', 'name'],
        tableColumns: [
          {
            prop: 'code',
            label: 'Código Regional',
            minWidth: 200
          },
          {
            prop: 'name',
            label: 'Nombre Regional',
            minWidth: 250
          },
        ],
      }
    },
    methods: {
        /***
         * Función para setear en la tabla los datos que llegan desde la Regional
         */
        setRegionals(regionals){
          var vm = this;
          for(let i=0;i<regionals.edges.length;i++)
          {
            vm.pushData(regionals.edges[i].node);
          }
          vm.orderData();  
        },
        /*** 
        * Función que valida si se está enviando o cargando datos
        */
        handleLoading(){
          if(isLoading == true || isSending == true){
            return true
          }
          else{
            return false
          }
        },
        /*** 
        * Función que se dispara cuando se da clic en Agregar regional
        */
        handleAdd (){
            var vm = this;
            let promise = new Promise(function(resolve, reject) {
              vm.resetForm();
              vm.formName = 'Agregar regional';
              vm.setVisibleForm(true,false)//Asignamos las variables de visualización del formulario
              vm.errors.clear();//Borramos las validaciones en los campos.
              resolve();
            }).then(function(resolve){
              vm.focusFirstField();
            });
            
        },
        /*** 
        * Función que se dispara cuando se da clic en Editar regional
        */
        handleEdit (index, row) {
              var vm = this;
              vm.rowEdit = row;
              let promise = new Promise(function(resolve, reject) {
              vm.formName = 'Editar regional';
              vm.model.id = row.id;
              vm.model.code = row.code;
              vm.model.name = row.name;
              vm.model.isActive = row.isActive;
              vm.setVisibleForm(false,true)//Asignamos las variables de visualización del formulario
              vm.errors.clear();//Borramos las validaciones en los campos.
              resolve();
            }).then(function(resolve){
              vm.focusFirstField();
            });
        },
        /*** 
        * Función que se dispara cuando se da clic en Desactivar regional
        */
        handleDeactivate (index, row) {
            var vm = this;
            swal({
                title: '¿Estás seguro?',
                text: 'Si aceptas, desactivarás la regional seleccionada',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, desactivar',
                cancelButtonText: 'No, cancelar',
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false
            }).then(() => {
                  this.isSending = true;
                  var id = vm.idDecode(row.id);
                  this.$apollo.mutate({
                    mutation: CREATE_REGIONAL,
                    variables : {
                        input :  {
                                  id : id,
                                  code : row.code,
                                  name : row.name,
                                  isActive : false
                            }
                      }
                  }).then((data) => {
                    let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
                    if (indexToDelete >= 0) {
                    this.tableData.splice(indexToDelete, 1)
                    }
                    this.pushData(data.data.regional.regional);
                    this.orderData();
                    this.isSending = false;
                    swal({
                    title: '¡Desactivado!',
                    text: 'La regional seleccionada ha sido desactivada',
                    type: 'success',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    buttonsStyling: false
                    }).then(() => {
                        vm.reloadData();
                    },function (dismiss){
                        vm.reloadData();
                    });
                  }).catch((error) => {
                    vm.isSending = false;
                    vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                  });
                
            }, function (dismiss) {
                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                swal({
                    title: 'Cancelado',
                    text: 'La regional no ha sido desactivada',
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                })
                })    
        },
        /*** 
        * Función que se dispara cuando se da clic en Activar regional
        */
        handleActivate (index, row) {
            var vm = this;
            swal({
                title: '¿Estás seguro?',
                text: 'Si aceptas, activarás la regional seleccionada',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, activar',
                cancelButtonText: 'No, cancelar',
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false
            }).then(() => {
                  this.isSending = true;
                  var id = vm.idDecode(row.id);
                  this.$apollo.mutate({
                    mutation: CREATE_REGIONAL,
                    variables : {
                        input :  {
                                  id : id,
                                  code : row.code,
                                  name : row.name,
                                  isActive : true
                            }
                      }
                  }).then((data) => {
                    let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
                    if (indexToDelete >= 0) {
                    this.tableData.splice(indexToDelete, 1)
                    }
                    this.pushData(data.data.regional.regional);
                    this.orderData();
                    this.isSending = false;
                    swal({
                    title: '¡Activada!',
                    text: 'La regional seleccionada ha sido activada',
                    type: 'success',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    buttonsStyling: false
                    }).then(() => {
                        vm.reloadData();
                    },function (dismiss){
                        vm.reloadData();
                    });
                  }).catch((error) => {
                    vm.isSending = false;
                    vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                  });
                
            }, function (dismiss) {
                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                swal({
                    title: 'Cancelado',
                    text: 'La regional no ha sido activada',
                    type: 'error',
                    confirmButtonClass: 'btn btn-info btn-fill',
                    buttonsStyling: false
                })
                })    
        },
        /**
        * Función que pone el foco en el campo de name
        */
        focusFirstField(){
          var vm = this;
          if(vm.addRegional)
          {
            this.$refs.code.$el.children[0].focus();//Asignamos focus en el campo
          }
          else if(vm.editRegional)
          {
            this.$refs.name.$el.children[0].focus();//Asignamos focus en el campo
          }
          
        },
        /**
        * Función para asignar el true o false a las opciones de agregar y editar regionales
        */
        setVisibleForm(add,edit)
        {
          this.addRegional = add;
          this.editRegional = edit;
        },
        /*** 
        * Función que resetea el formulario
        */
        resetForm(){
            this.model.id = '';
            this.model.code = '';
            this.model.name = '';
            this.model.isActive = true;
        },
        /*** 
        * Función que cancela la creación/edición de regional y resetea los campos
        */
        cancelForm(){
            this.resetForm();
            this.addRegional = false;
            this.editRegional = false;
            this.errors.clear();
            window.scrollTo(0,0);
            // this.$router.go();
        },
        /*** 
        * Función que permite visualizar los errores en cada campo del input
        */
        getError (fieldName) {
            return this.errors.first(fieldName)
        },
        /*** 
        * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
        */
        onSuccess(message){
            swal({
                title: `¡Correcto!`,
                text: message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-success btn-fill',
                type: 'success'
            });
        },
        /*** 
        * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
        */
        onError(message){
            swal({
                title: `¡Alerta!`,
                text: message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger btn-fill',
                type: 'error'
            });
        },
        /*** 
        * Función que oculta el formulario de creación/edición una vez realizado un envío de datos al servidor
        */
        reloadData(){
            var vm = this;
            vm.resetForm();
            vm.setVisibleForm(false,false)//Asignamos las variables de visualización del formulario 
        },
        /***
        * Función para agregar un objeto al arreglo de datos
        */
        pushData(node){
            var vm = this;
            vm.tableData.push({
              id: node.id,
              code: node.code,
              name: node.name,
              isActive: node.isActive,
            });
        },
        /***
        * Función para ordenar el arreglo de datos
        */
        orderData(){
            var vm = this;
            const myOrderedArray = _.sortBy(vm.tableData, o => o.name);
            vm.tableData = myOrderedArray;
        },
        /***
        * Función para decodificar el ID en base 64
        */
        idDecode(id){
            let id_decoded = atob(id);
            return id_decoded.split(":")[1];
        },
        /***
         * Función para validar el formulario de edición y creación que se envía
         */
        validate () {
            this.$validator.validateAll().then(isValid => {
              if(isValid){
                  // this.$emit('on-submit', this.registerForm, isValid)
                  var vm = this;
                  var formInput = {};
                  var formMessage = ""; 
                  vm.isSending = true;
                  if(vm.addRegional && !vm.editRegional)
                  {
                      formInput = {
                            code: vm.model.code,
                            name: vm.model.name,
                            isActive: true
                      };
                      formMessage = "Regional registrada con éxito";
                  }
                  else if(!vm.addRegional && vm.editRegional)
                  {
                      var id = vm.idDecode(vm.model.id);
                      formInput = {
                            id: id,
                            code: vm.model.code,
                            name: vm.model.name,
                            isActive: vm.model.isActive
                      };
                      formMessage = "Regional editada con éxito";
                  }
                  // Iniciamos el envío de la mutación
                  this.$apollo.mutate({
                    mutation: CREATE_REGIONAL,
                    variables : {
                        input : formInput
                      }
                  }).then((data) => {
                    if(!vm.addRegional && vm.editRegional)
                    {
                      let indexToDelete = vm.tableData.findIndex((tableRow) => tableRow.id === vm.rowEdit.id)
                      if (indexToDelete >= 0) {
                      vm.tableData.splice(indexToDelete, 1)
                      }
                    }
                    vm.pushData(data.data.regional.regional);
                    vm.orderData();
                    vm.isSending = false;
                    vm.onSuccess(formMessage);
                    vm.reloadData();
                  }).catch((error) => {
                    vm.isSending = false;
                    vm.onError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                  });
              }
            })
      }
    },
    mounted() {
        // this.test();
        // alert(this.$window.csrf_token);
    }
  }
</script>
<style lang="scss">
  .el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
  }
  // Función para centrar la imagen del Empty State
  .no_data_center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 70%;
  }
  // Estilos para poder centrar el título de la Regional
  .center-title {
    margin-top: 0;
    margin-bottom: 0;
  }
</style>
